/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const reviewSocialProfileSuggestionDtoSchema = z.object({
    "status": z.enum(["accepted", "rejected"]).describe("'accepted' adds the suggested URL to the contact's links; 'rejected' discards it for good")
    })